import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { LAYOUT_COLUMN__right } from '@/pages/_base/layout_base/LAYOUT_COLUMN__right';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { useMemo } from 'react';
import { G_SIDEBAR__edges } from '../../../sidebar/G_SIDEBAR__edges';
import { G_SIDEBAR__fields } from '../../../sidebar/G_SIDEBAR__fields';
import { G_LIST__node_neighbours } from './G_LIST__node_neighbours';

export function G_SIDEBAR__graph_node_fields() {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_graph__node_id_selected, g_graph__edge_id_selected } = use_slice_ui(['g_graph__node_id_selected', 'g_graph__edge_id_selected']);

  let { graph } = generation_current.tool;

  const predecessors = useMemo(() => get_predecessors(), [g_graph__node_id_selected, graph]);
  const successors = useMemo(() => get_successors(), [g_graph__node_id_selected, graph]);

  /*
   * METHODS
   */

  function get_fields() {
    let out_from_node = get_fields_from_selected_node();
    let out_from_edge = get_fields_from_selected_edge();

    let out = [...out_from_node, ...out_from_edge];

    out = out.filter(item => item.meta.ui__has_component);

    return out;
  }

  function get_fields_from_selected_node() {
    if (g_graph__node_id_selected === ENUM__string_id_empty.UUID) return [];

    const node = graph.node__get(g_graph__node_id_selected);

    return node.fields__get_with_ui_component();
  }

  function get_fields_from_selected_edge() {
    if (g_graph__edge_id_selected === ENUM__string_id_empty.UUID) return [];

    const edge = graph.edge__get_by_id(g_graph__edge_id_selected);

    let field_from = graph.field__get_by_id(edge.field_from__field_id);

    return [field_from];
  }

  /*
   *
   */

  function get_predecessors() {
    if (g_graph__node_id_selected === ENUM__string_id_empty.UUID) return [];

    let graph_dagree = graph.dagre__convert_to();

    let ids = graph.dagre__get_nodes_ids_to(graph_dagree, g_graph__node_id_selected);

    return graph.nodes__get(ids);
  }

  function get_successors() {
    if (g_graph__node_id_selected === ENUM__string_id_empty.UUID) return [];

    let graph_dagree = graph.dagre__convert_to();

    let ids = graph.dagre__get_nodes_ids_from(graph_dagree, g_graph__node_id_selected);

    return graph.nodes__get(ids);
  }

  function get_edges_to() {
    if (g_graph__node_id_selected === ENUM__string_id_empty.UUID) return [];

    let node = graph.nodes_map.get_or_assert(g_graph__node_id_selected);

    let fields_map = node.fields__get_map(true);

    let out = graph.edges__get_to(fields_map.values());

    return out;
  }

  function get_edges_from() {
    if (g_graph__node_id_selected === ENUM__string_id_empty.UUID) return [];

    let node = graph.nodes_map.get_or_assert(g_graph__node_id_selected);

    let fields_map = node.fields__get_map(true);

    let out = graph.edges__get_from(fields_map.values());

    return out;
  }

  function is_selected_node_or_edge_from_graph() {
    let is_selected_node = graph.nodes_map.has(g_graph__node_id_selected);
    let is_selected_edge = graph.edges.some(edge => edge.edge_id == g_graph__edge_id_selected);

    return is_selected_node || is_selected_edge;
  }

  /*
   * HTML
   */

  if (!is_selected_node_or_edge_from_graph()) return [];

  return (
    <LAYOUT_COLUMN__right could_be_hidden>
      <div className="size-full flex flex-col overflow-auto">
        <G_LIST__node_neighbours title="Predecessors" nodes_list={predecessors} />
        <G_LIST__node_neighbours title="Successors" nodes_list={successors} />
        <G_SIDEBAR__edges title="Edges to" edges={get_edges_to()} name_type={'to'} className="" />
        <G_SIDEBAR__edges title="Edges from" edges={get_edges_from()} name_type={'from'} className="" />
        <G_SIDEBAR__fields fields={get_fields()} />
      </div>
    </LAYOUT_COLUMN__right>
  );
}
